export { default as RatingStats } from './RatingStats';
